// SVGs
import { ReactComponent as ExternalApplication16 } from "../scenes/stack/environment/icons/asset_icon/assets-externalapp-24.svg";
import { ReactComponent as InternalApplication16 } from "../scenes/stack/environment/icons/asset_icon/assets-internalapp-24.svg";
import { ReactComponent as KeyPeople16 } from "../scenes/stack/environment/icons/asset_icon/assets-key-people-24.svg";
import { ReactComponent as SensitiveData16 } from "../scenes/stack/environment/icons/asset_icon/assets-sensitive-data-24.svg";
import { ReactComponent as firewallIcon } from "../scenes/stack/environment/icons/firewall_icon_24.svg";
import { ReactComponent as VulnerabilityStep } from "../scenes/stack/environment/icons/vulnerability_step.svg";
import { ReactComponent as CrowdStrikeLogo } from "../scenes/stack/integrations/logos/CrowdStrike.svg";
import { ReactComponent as GoogleLogo } from "../scenes/stack/integrations/logos/google.svg";
import { ReactComponent as OktaLogo } from "../scenes/stack/integrations/logos/Okta.svg";
import { ReactComponent as AbuseActiveDirectoryDelegationFeature } from "./icon_files/abuse_active_directory_delegation_feature.svg";
import { ReactComponent as AbuseActiveDirectoryUnconstrainedDelegation } from "./icon_files/abuse_active_directory_unconstrained_delegation.svg";
import { ReactComponent as AbuseLegitimateService } from "./icon_files/abuse_legitimate_service.svg";
import { ReactComponent as AbusingOfflineSecurityAgent } from "./icon_files/abusing_offline_security_agent.svg";
import { ReactComponent as AbusingPrivilegedRoles } from "./icon_files/abusing_roles.svg";
import { ReactComponent as AccessDataAtRest } from "./icon_files/access_data_at_rest.svg";
import { ReactComponent as AccessDataOverTheNetwork } from "./icon_files/access_data_over_the_network.svg";
import { ReactComponent as AccessToConsoleOverThePublicInternet } from "./icon_files/access_to_console_over_the_public_internet.svg";
import { ReactComponent as AccessToCredentials } from "./icon_files/access_to_credentials.svg";
import { ReactComponent as appIcon } from "./icon_files/appIcon.svg";
import { ReactComponent as ApplicationLevelAttack } from "./icon_files/application_level_attack.svg";
import { ReactComponent as AttackerLogo } from "./icon_files/attacker.svg";
import { ReactComponent as BypassSystemSecurityControls } from "./icon_files/bypass_system_security_controls.svg";
import { ReactComponent as CloudConsole } from "./icon_files/cloud_console.svg";
import { ReactComponent as CodeExecutionViaCommandAndControl } from "./icon_files/code_execution_via_command_and_control.svg";
import { ReactComponent as CrackWeakRSAKey } from "./icon_files/crack_weak_rsa_key.svg";
import { ReactComponent as Credentials } from "./icon_files/credentials.svg";
import { ReactComponent as CredentialsAbuse } from "./icon_files/credentials_abuse.svg";
import { ReactComponent as Diamond } from "./icon_files/Diamond.svg";
import { ReactComponent as DisabledSystemsSecurityControls } from "./icon_files/disabled_systems_security_controls.svg";
import { ReactComponent as eksClusterIcon } from "./icon_files/eks_cluster.svg";
import { ReactComponent as Email } from "./icon_files/email.svg";
import { ReactComponent as EmailCompromise } from "./icon_files/email_compromise.svg";
import { ReactComponent as FingerprintRounded } from "./icon_files/FingerprintRounded.svg";
import { ReactComponent as Hosts } from "./icon_files/Hosts.svg";
import { ReactComponent as Internet } from "./icon_files/Internet.svg";
import { ReactComponent as Inventory } from "./icon_files/inventory.svg";
import { ReactComponent as LoginToAdminConsole } from "./icon_files/login_to_console.svg";
import { ReactComponent as LoginToPortal } from "./icon_files/login_to_portal.svg";
import { ReactComponent as MaliciousCodeInjection } from "./icon_files/malicious_code_injection.svg";
import { ReactComponent as MaliciousFileExecute } from "./icon_files/malicious_file_execute.svg";
import { ReactComponent as MaliciousFilesDownloadedToEndpoint } from "./icon_files/malicious_files_downloaded_to_endpoint.svg";
import { ReactComponent as MaliciousFilesWrittenToDisk } from "./icon_files/malicious_files_written_to_disk.svg";
import { ReactComponent as MCPServerIcon } from "./icon_files/mcp_icon.svg";
import { ReactComponent as MFABypassExploited } from "./icon_files/mfa_bypass_exploited.svg";
import NonhumanIdentityIcon from "./icon_files/NonHumanIdentityIcon";
import { ReactComponent as PasswordBruteForceAttack } from "./icon_files/password_brute_force_attack.svg";
import { ReactComponent as PasswordSprayAttack } from "./icon_files/password_spray_attack.svg";
import { ReactComponent as RemoveData } from "./icon_files/remove_data.svg";
import { ReactComponent as SharedPasswordAbuse } from "./icon_files/shared_password_abuse.svg";
import { ReactComponent as StaticExecution } from "./icon_files/static_execution.svg";
import { ReactComponent as StaticExecutionExternalApplication } from "./icon_files/static_execution_external_application.svg";
import { ReactComponent as StaticExecutionInternalApplication } from "./icon_files/static_execution_internal_application.svg";
import { ReactComponent as StaticExecutionKeyPeople } from "./icon_files/static_execution_key_people.svg";
import { ReactComponent as StaticExecutionSensitiveData } from "./icon_files/static_execution_sensitive_data.svg";
import { ReactComponent as UserAccountWithExcessiveAdminPermissions } from "./icon_files/user_account_with_excessive_permissions.svg";
import { ReactComponent as WeakPasswordExploitation } from "./icon_files/weak_password_exploitation.svg";

export const descriptionToSVGbyCategory = {
  step_vector: {
    // TODO steps not in use, add icons in https://linear.app/breeze-security/issue/DEV-1208/design-missing-icons-for-steps
    "A Google user can modify a GCP-Privileged group": StaticExecution,
    "Abuse Active Directory Krbtgt Account": StaticExecution,
    "Abuse Active Directory Vulnerable Permissions": StaticExecution,
    "Active Directory Kerberoasting": StaticExecution,
    "Abuse Active Directory Unconstrained Delegation":
      AbuseActiveDirectoryUnconstrainedDelegation,
    "Abuse Active Directory Delegation feature":
      AbuseActiveDirectoryDelegationFeature,
    // in use
    "Login to Admin console": LoginToAdminConsole,
    "Abusing privileged roles": AbusingPrivilegedRoles,
    "Malicious file executed": MaliciousFileExecute,
    "Malicious file written to disk": MaliciousFilesWrittenToDisk,
    "Weak password exploitation": WeakPasswordExploitation,
    "Credentials Abuse": CredentialsAbuse,
    "Login to Portal": LoginToPortal,
    "Access to credentials": AccessToCredentials,
    "MFA Bypass Exploited": MFABypassExploited,
    "Password bruteforce attack": PasswordBruteForceAttack,
    "Password-spray attack": PasswordSprayAttack,
    "Access to console over the public Internet":
      AccessToConsoleOverThePublicInternet,
    "Code execution via Command and Control": CodeExecutionViaCommandAndControl,
    "Access data at rest": AccessDataAtRest,
    "Shared password abuse": SharedPasswordAbuse,
    "Disabled system's security controls": DisabledSystemsSecurityControls,
    "User account with excessive admin permissions":
      UserAccountWithExcessiveAdminPermissions,
    "Malicious files downloaded to endpoint":
      MaliciousFilesDownloadedToEndpoint,
    "Access data over the network": AccessDataOverTheNetwork,
    "Remove data": RemoveData,
    "Application-level attack": ApplicationLevelAttack,
    "Abuse legitimate service": AbuseLegitimateService,
    "Malicious code injection": MaliciousCodeInjection,
    "Crack weak RSA key": CrackWeakRSAKey,
    "Abusing offline security agent": AbusingOfflineSecurityAgent,
    "Bypass system's security controls": BypassSystemSecurityControls,
    "Vulnerability exploitation": VulnerabilityStep,
    mailbox_compromise: EmailCompromise,
  },
  execution_step: {
    StaticExecutionSensitiveData: StaticExecutionSensitiveData,
    StaticExecutionKeyPeople: StaticExecutionKeyPeople,
    StaticExecutionExternalApplication: StaticExecutionExternalApplication,
    StaticExecutionInternalApplication: StaticExecutionInternalApplication,
    StaticExecution: StaticExecution,
  },
  asset: {
    "Key People": KeyPeople16,
    "Internal Application": InternalApplication16,
    "External Application": ExternalApplication16,
    "Sensitive Data": SensitiveData16,
    Other: Diamond,
  },
  location: {
    Crowdstrike: CrowdStrikeLogo,
    Google: GoogleLogo,
    Okta: OktaLogo,
    Attacker: AttackerLogo,
    "Cloud Console": CloudConsole,
    Credentials: Credentials,
    Internet: Internet,
    Endpoint: Hosts,
    "Physical Access": FingerprintRounded,
    mailbox: Email,
  },
  entity: {
    nonhuman_identity: NonhumanIdentityIcon,
    app: appIcon,
    Inventory: Inventory,
    eks_cluster: eksClusterIcon,
    firewall: firewallIcon,
    mcp_server: MCPServerIcon,
  },
};

const descriptorToIconFromSVG = Object.entries(
  descriptionToSVGbyCategory
).reduce((acc, [key, value]) => {
  return { ...acc, ...value };
}, {});

export default descriptorToIconFromSVG;
